export default __webpack_public_path__ + "static/media/shi.93df47e1.jpg";